export const ADVISORY_DISPLAY_DURATION_IN_SECONDS = 5;

// NOTE: adding 200ms for controls auto-hide animation to complete
export const CHAPTER_START_OFFSET_IN_SECONDS = 5.2;

export const OPENING_CREDITS_CHAPTER_TYPE = 'opening_credits';

export const INTRO_CHAPTER_TYPE = 'intro';

export const ENDING_CREDITS_CHAPTER_TYPE = 'ending_credits';

export const START_CHAPTERS_TYPES = [OPENING_CREDITS_CHAPTER_TYPE, INTRO_CHAPTER_TYPE];

export const END_CHAPTERS_TYPES = [ENDING_CREDITS_CHAPTER_TYPE];
